import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getPagesIntroduction = () =>
  axiosInstance.get(`${LANDING_API_URL}/get-page-introduction`, {
    headers: authHeaders(),
  });

export const createPageIntroductionRequest = (pageData) =>
  axiosInstance.post(`${LANDING_API_URL}/page-introduction`, pageData, {
    headers: authHeaders(),
  });

export const updatePageIntroductionRequest = (pageKey, pageData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/update-page-introduction/${pageKey}`,
    pageData,
    {
      headers: authHeaders(),
    },
  );

export const removePageIntroduction = (pageKey) =>
  axiosInstance.delete(
    `${LANDING_API_URL}/delete-page-introduction/${pageKey}`,
    {
      headers: authHeaders(),
    },
  );
